module.exports = __webpack_public_path__ + "img/Hamster.ddb48a89.png";